import appLogger from '@shared/logging/appLogger';
import { ResultItem } from '@shared/types/search';
import { parseBadgeLabel } from '@shared/utilities/helper/adobe';

const logClickEvent = (linkText: string, linkPosition = 'Saved Search') => {
    appLogger.logEvent({
        name: 'Click',
        properties: {
            linkOriginatingPageName: 'Layout - Saved Searches',
            linkText: linkText,
            linkPosition: linkPosition,
        },
    });
};

export const getProductSearchModel = (vehicle: ResultItem, positionNumber?: number) => {
    if (!vehicle) return { items: [] };

    const category = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;
    const stockNum = vehicle.stockNum;
    const cost = vehicle?.auction?.floorPrice?.amount ?? 0;
    const event45 = 1;
    const event545 = 1;

    let evar81 = '';
    if (positionNumber !== undefined) {
        const position = positionNumber + 1;
        const badgeLabel = vehicle.badgeLabel ?? 'Not Applicable';
        if (vehicle.badgeLabel) {
            const { label, visibility } = parseBadgeLabel(badgeLabel);
            evar81 = `${position}:${label}:${visibility}`;
        } else {
            evar81 = `${position}:${badgeLabel}`;
        }
    }

    return {
        items: [
            {
                category,
                stockNum,
                cost,
                event45, // current thinking is event45 for all click events related to vehicle
                event545,
                evar81,
            },
        ],
    };
};

export const getProductVDPModel = (stockNum: string, vehicle: ResultItem) => ({
    items: vehicle && [
        {
            category: `${vehicle.year} ${vehicle.make} ${vehicle.model}`,
            stockNum: stockNum,
            cost: vehicle?.auction?.floorPrice?.amount ?? 0,
            event45: 1, // current thinking is event45 for all click events related to vehicle
            event545: 1,
            evar81: '',
            // evar81: `${positionNumber + 1}:${'not applicable'}`, // TODO: Tech debt https://dev.azure.com/CarMax/KMX-Product/_workitems/edit/146402
        },
    ],
});

export default logClickEvent;
